<div>
    <p-chart 
        #chart type="bar"
        [data]="chartData"
        [options]="chartOptions"
        height="226px"
        *ngIf="chartData && chartData.datasets && chartData.datasets.length"
    ></p-chart>
</div>
<div class="custom-legend-container">
    <div
        *ngFor="let dataset of chartData?.datasets; let i = index" 
        class="legend-item"
        [class.is-hidden]="!isDatasetVisible(i)"
        (click)="toggleDataset(i)"
    >
        <span class="legend-color-box" [style.background-color]="dataset.backgroundColor" [class.disabled]="!isDatasetVisible(i)"></span>
        <span class="legend-label" [style.text-decoration]="isDatasetVisible(i) ? 'none' : 'line-through'">{{ dataset.label }}</span>
    </div>
</div>
